import axios from "axios";
import { API_GET_STORE_DATA, API_INSERT_STORE_DATA, API_TOGGLE_STORE_DATA, API_UPDATE_STORE_DATA } from ".";

export const getStoreList = async (func, config) => {
    return axios.get(API_GET_STORE_DATA, config).then(res => func(res.data.data));
}

export const insertStoreData = async (data, config) => {
    return axios.post(API_INSERT_STORE_DATA, data, config).then((res) => res.data);
};

export const updateStoreData = async (data, config) => {
    return axios.put(API_UPDATE_STORE_DATA, data, config).then((res) => res.data);
};

export const toggleStoreData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_STORE_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};